export default __webpack_public_path__ + "static/media/peep-17.f38eb768.svg";